/* tslint:disable:max-line-length */
import { FuseNavigationItem, FuseNavigationModule } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Home',
        type: 'basic',
        icon: 'mat_outline:home',
        link: '/home'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Home',
        type: 'basic',
        icon: 'mat_outline:home',
        link: '/home'
    },
    {
        id: 'clients',
        title: 'Clients',
        type: 'basic',
        icon: 'heroicons_outline:office-building',
        link: '/admin/clients/list'
    },
    {
        id: 'audits',
        title: 'Audits',
        type: 'basic',
        icon: 'heroicons_outline:identification',
        link: '/admin/audits'
    },
    {
        id: 'billing',
        title: 'Billing',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/admin/billing'
    },
    {
        id: 'documents',
        title: 'Document Manager',
        type: 'basic',
        icon: 'heroicons_outline:document',
        link: '/admin/documents'
    },
    {
        id: 'files',
        title: 'File Manager',
        type: 'basic',
        icon: 'heroicons_outline:document-search',
        link: '/admin/file-manager'
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'basic',
        icon: 'heroicons_outline:presentation-chart-line',
        link: '/admin/reports'
    },
    {
        id: 'quote-requests',
        title: 'Applications',
        type: 'basic',
        icon: 'mat_outline:request_quote',
        link: '/admin/quotes'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Home',
        type: 'basic',
        icon: 'mat_outline:home',
        link: '/home'
    },
    {
        id: 'clients',
        title: 'Clients',
        type: 'group',
        icon: 'heroicons_outline:office-building',
        children: [
            {
                id: 'clients.search',
                title: 'Search',
                type: 'basic',
                icon: 'heroicons_outline:office-building',
                link: '/clients/list'
            },
            {
                id: 'clients.application',
                title: 'Applications',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-list',
                link: '/applications'
            }
        ]
    },
    {
        id: 'audits',
        title: 'Audit Scheduling',
        type: 'basic',
        icon: 'mat_outline:travel_explore',
        link: '/admin/audits'
    },
    {
        id: 'billing',
        title: 'Billing',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/admin/billing'
    },
    {
        id: 'documents',
        title: 'Document Manager',
        type: 'basic',
        icon: 'heroicons_outline:document',
        link: '/admin/documents'
    },
    {
        id: 'files',
        title: 'File Manager',
        type: 'basic',
        icon: 'heroicons_outline:document-search',
        link: '/admin/file-manager'
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'basic',
        icon: 'heroicons_outline:presentation-chart-line',
        link: '/reports'
    },
    {
        id: 'audits',
        title: 'Audit Scheduling',
        type: 'basic',
        icon: 'mat_outline:travel_explore',
        link: '/admin/audits'
    },
];

export const adminNavigation: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Home',
        type: 'basic',
        icon: 'mat_outline:home',
        link: '/home'
    },
    {
        id: 'admin',
        title: 'Admin',
        type: 'group',
        icon: 'mat_outline:admin_panel_settings',
        children: [
            {
                id: 'clients',
                title: 'Clients',
                type: 'group',
                icon: 'mat_outline:business',
                children: [
                    {
                        id: 'clients-list',
                        title: 'Clients',
                        type: 'basic',
                        icon: 'mat_outline:view_list',
                        link: '/admin/clients/list'
                    },
                    {
                        id: 'clients-report',
                        title: 'Reports',
                        type: 'basic',
                        icon: 'mat_outline:view_list',
                        link: '/admin/clients/client-reports'
                    },
                    {
                        id: 'clients-add',
                        title: 'Add New Client',
                        type: 'basic',
                        icon: 'mat_outline:add_circle_outline',
                        link: '/admin/clients/add'
                    },
                    {
                        id: 'clients-add-old',
                        title: 'Add New Client Old Form',
                        type: 'basic',
                        icon: 'mat_outline:add_circle_outline',
                        link: '/admin/clients/add-old'
                    },
                ]
            },
            {
                id: 'sales',
                title: 'Sales',
                type: 'group',
                icon: 'mat_outline:attach_money',
                children: [
                    {
                        id: 'sales-quote-requests',
                        title: 'Applications',
                        type: 'basic',
                        icon: 'mat_outline:send_and_archive',
                        link: '/admin/sales/quote-requests'
                    },
                    {
                        id: 'sales-quotes',
                        title: 'Quotes',
                        type: 'basic',
                        icon: 'mat_outline:request_quote',
                        link: '/admin/sales/quotes'
                    },
                ]
            },
            {
                id: 'audits',
                title: 'Audits',
                type: 'group',
                icon: 'mat_outline:travel_explore',
                children: [
                    {
                        id: 'audits-list',
                        title: 'Audits',
                        type: 'basic',
                        icon: 'mat_outline:view_list',
                        link: '/admin/audits/list'
                    },
                    {
                        id: 'audits-calendar',
                        title: 'Audit Calendar',
                        type: 'basic',
                        icon: 'mat_outline:calendar_today',
                        link: '/admin/audits/calendar'
                    },
                    {
                        id: 'audits-certificates',
                        title: 'Audit Certificates',
                        type: 'basic',
                        icon: 'heroicons_outline:office-building',
                        link: '/admin/audits/certificates'
                    },
                    {
                        id: 'risk-matrix',
                        title: 'Risk Matrix',
                        type: 'basic',
                        icon: 'heroicons_outline:shield-exclamation',
                        link: '/admin/audits/risk-matrix'
                    }
                ]
            },
            {
                id: 'billing',
                title: 'Billing',
                type: 'group',
                icon: 'heroicons_outline:currency-dollar',
                children: [
                    {
                        id: 'expenses-list',
                        title: 'Expenses',
                        type: 'basic',
                        icon: 'mat_outline:view_list',
                        link: '/admin/billing/expenses/list'
                    },
                    {
                        id: 'invoices-list',
                        title: 'Invoices',
                        type: 'basic',
                        icon: 'mat_outline:receipt',
                        link: '/admin/invoice/list'
                    },
                ]
            },
            {
                id: 'personnel',
                title: 'Personnel',
                type: 'group',
                icon: 'mat_outline:badge',
                children: [
                    {
                        id: 'personnel-users',
                        title: 'Users',
                        type: 'basic',
                        icon: 'mat_outline:manage_accounts',
                        link: '/admin/personnel/users'
                    },
                    {
                        id: 'personnel-auditors',
                        title: 'Auditors',
                        type: 'basic',
                        icon: 'mat_outline:rate_review',
                        link: '/admin/personnel/auditors'
                    },
                    {
                        id: 'personnel-sales',
                        title: 'Sales Reps',
                        type: 'basic',
                        icon: 'mat_outline:support_agent',
                        link: '/admin/personnel/sales-rep'
                    },
                    {
                        id: 'personnel-staff',
                        title: 'Staff/Committees',
                        type: 'basic',
                        icon: 'mat_outline:badge',
                        link: '/admin/personnel/staff'
                    },
                    {
                        id: 'personnel-clients',
                        title: 'Clients',
                        type: 'basic',
                        icon: 'mat_outline:badge',
                        link: '/admin/personnel/client'
                    },
                    {
                        id: 'personnel-mmr',
                        title: 'MMR',
                        type: 'basic',
                        icon: 'mat_outline:badge',
                        link: '/admin/personnel/mmr'
                    }
                ]
            },
            {
                id: 'documents',
                title: 'Documents',
                type: 'group',
                icon: 'mat_outline:snippet_folder',
                children: [
                    {
                        id: 'documents-control',
                        title: 'Document Control',
                        type: 'basic',
                        icon: 'mat_outline:folder_special',
                        link: '/admin/documents'
                    },
                    {
                        id: 'audit-document-templates',
                        title: 'Audit Document Templates',
                        type: 'basic',
                        icon: 'mat_outline:folder_special',
                        link: '/admin/document-templates'
                    },
                    {
                        id: 'documents-files',
                        title: 'File Manager',
                        type: 'basic',
                        icon: 'mat_outline:folder_shared',
                        link: '/admin/file-manager'
                    },
                ]
            },
            {
                id: 'settings',
                title: 'Settings',
                type: 'group',
                icon: 'mat_outline:settings',
                link: '/admin/settings',
                children: [
                    {
                        id: 'settings-options',
                        icon: 'mat_outline:dynamic_form',
                        title: 'Options',
                        type: 'basic',
                        link: '/admin/settings/options'
                    },
                    {
                        id: 'settings-standards',
                        link: '/admin/settings/standards',
                        icon: 'mat_outline:integration_instructions',
                        title: 'Standards',
                        type: 'basic',
                    },
                    {
                        id: 'settings-industry-code',
                        link: '/admin/settings/industry-code',
                        icon: 'mat_outline:checklist',
                        title: 'Industry Codes',
                        type: 'basic',
                    },
                    {
                        id: 'settings-industry-competency',
                        link: '/admin/settings/industry-competency',
                        icon: 'mat_outline:checklist',
                        title: 'Industry Competencies',
                        type: 'basic',
                    },
                    {
                        id: 'settings-test-manager',
                        link: '/admin/settings/test-manager',
                        icon: 'mat_outline:folder_open',
                        title: 'Test Management',
                        type: 'basic',
                    },
                    {
                        id: 'settings-legal',
                        link: '/admin/settings/legal',
                        icon: 'mat_outline:gavel',
                        title: 'Legal',
                        type: 'basic',
                    },
                    {
                        id: 'settings-geo',
                        link: '/admin/settings/geo',
                        icon: 'mat_outline:map',
                        title: 'Geography',
                        type: 'basic',
                    },
                    {
                        id: 'settings-schema-manager',
                        link: '/admin/settings/schema',
                        icon: 'mat_outline:settings_input_component',
                        title: 'Schema Manager',
                        type: 'basic',
                    },
                    {
                        id: 'settings-quote-profiles',
                        link: '/admin/settings/quote-profiles',
                        icon: 'mat_outline:manage_accounts',
                        title: 'Sales Quote Profiles',
                        type: 'basic',
                    },
                    {
                        id: 'settings-expense-report-options',
                        link: '/admin/settings/expense-report-options',
                        icon: 'mat_outline:manage_accounts',
                        title: 'Expense Report Options',
                        type: 'basic',
                    }
                ]
            },
            {
                id: 'email-manager',
                title: 'Email Manager',
                type: 'collapsable',
                icon: 'mat_outline:email',
                link: '/admin/email-manager',
                children: [
                    {
                        id: 'email-manager-email-history',
                        link: '/admin/email-manager/email-history',
                        icon: 'mat_outline:email',
                        title: 'Email History',
                        type: 'basic',
                    }
                ]
            },
            {
                id: 'Activity',
                title: 'Activity Console',
                type: 'basic',
                icon: 'mat_outline:sync_alt',
                link: '/admin/activity'
            }
        ]
    },


];

export const adminCompactNavigation: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Home',
        type: 'basic',
        icon: 'mat_outline:home',
        link: '/home'
    },
    {
        id: 'clients',
        title: 'Clients',
        type: 'collapsable',
        icon: 'mat_outline:business',
        children: [
            {
                id: 'clients-list',
                title: 'Clients',
                type: 'basic',
                icon: 'mat_outline:view_list',
                link: '/admin/clients/list'
            },
            {
                id: 'clients-report',
                title: 'Reports',
                type: 'basic',
                icon: 'mat_outline:view_list',
                link: '/admin/clients/client-reports'
            },
            {
                id: 'clients-add',
                title: 'Add New Client',
                type: 'basic',
                icon: 'mat_outline:add_circle_outline',
                link: '/admin/clients/add'
            },
            {
                id: 'clients-add-old',
                title: 'Add New Client Old Form',
                type: 'basic',
                icon: 'mat_outline:add_circle_outline',
                link: '/admin/clients/add-old'
            },
        ]
    },
    {
        id: 'sales',
        title: 'Sales',
        type: 'collapsable',
        icon: 'mat_outline:attach_money',
        children: [
            {
                id: 'sales-quote-requests',
                title: 'Applications',
                type: 'basic',
                icon: 'mat_outline:send_and_archive',
                link: '/admin/sales/quote-requests'
            },
            {
                id: 'sales-quotes',
                title: 'Quotes',
                type: 'basic',
                icon: 'mat_outline:request_quote',
                link: '/admin/sales/quotes'
            },
        ]
    },
    {
        id: 'audits',
        title: 'Audits',
        type: 'collapsable',
        icon: 'mat_outline:travel_explore',
        children: [
            {
                id: 'audits-list',
                title: 'Audits',
                type: 'basic',
                icon: 'mat_outline:travel_explore',
                link: '/admin/audits/list'
            },
            {
                id: 'audits-calendar',
                title: 'Audit Calendar',
                type: 'basic',
                icon: 'mat_outline:calendar_today',
                link: '/admin/audits/calendar'
            },
            {
                id: 'audits-certificates',
                title: 'Audit Certificates',
                type: 'basic',
                icon: 'heroicons_outline:office-building',
                link: '/admin/audits/certificates'
            },
            {
                id: 'risk-matrix',
                title: 'Risk Matrix',
                type: 'basic',
                icon: 'heroicons_outline:shield-exclamation',
                link: '/admin/audits/risk-matrix'
            }
        ]
    },
    {
        id: 'billing',
        title: 'Billing',
        type: 'collapsable',
        icon: 'heroicons_outline:currency-dollar',
        children: [
            {
                id: 'expenses-list',
                title: 'Expenses',
                type: 'basic',
                icon: 'mat_outline:view_list',
                link: '/admin/billing/expenses/list'
            },
            {
                id: 'invoices-list',
                title: 'Invoices',
                type: 'basic',
                icon: 'mat_outline:receipt',
                link: '/admin/invoice/list'
            },
        ]
    },
    {
        id: 'personnel',
        title: 'Personnel',
        type: 'collapsable',
        icon: 'mat_outline:badge',
        children: [
            {
                id: 'personnel-users',
                title: 'Users',
                type: 'basic',
                icon: 'mat_outline:manage_accounts',
                link: '/admin/personnel/users'
            },
            {
                id: 'personnel-auditors',
                title: 'Auditors',
                type: 'basic',
                icon: 'mat_outline:rate_review',
                link: '/admin/personnel/auditors'
            },
            {
                id: 'personnel-sales',
                title: 'Sales Reps',
                type: 'basic',
                icon: 'mat_outline:support_agent',
                link: '/admin/personnel/sales-rep'
            },
            {
                id: 'personnel-staff',
                title: 'Staff/Committees',
                type: 'basic',
                icon: 'mat_outline:badge',
                link: '/admin/personnel/staff'
            },
            {
                id: 'personnel-clients',
                title: 'Clients',
                type: 'basic',
                icon: 'mat_outline:badge',
                link: '/admin/personnel/client'
            },
            {
                id: 'personnel-mmr',
                title: 'MMR',
                type: 'basic',
                icon: 'mat_outline:badge',
                link: '/admin/personnel/mmr'
            }
        ]
    },
    {
        id: 'documents',
        title: 'Documents',
        type: 'collapsable',
        icon: 'mat_outline:snippet_folder',
        children: [
            {
                id: 'documents-control',
                title: 'Document Control',
                type: 'basic',
                icon: 'mat_outline:folder_special',
                link: '/admin/documents'
            },
            {
                id: 'audit-document-templates',
                title: 'Audit Document Templates',
                type: 'basic',
                icon: 'mat_outline:folder_special',
                link: '/admin/document-templates'
            },
            {
                id: 'documents-files',
                title: 'File Manager',
                type: 'basic',
                icon: 'mat_outline:folder_shared',
                link: '/admin/file-manager'
            },
        ]
    },
    {
        id: 'settings',
        title: 'Settings',
        type: 'collapsable',
        icon: 'mat_outline:settings',
        link: '/admin/settings',
        children: [
            {
                id: 'settings-options',
                icon: 'mat_outline:dynamic_form',
                title: 'Options',
                type: 'basic',
                link: '/admin/settings/options'
            },
            {
                id: 'settings-standards',
                link: '/admin/settings/standards',
                icon: 'mat_outline:integration_instructions',
                title: 'Standards',
                type: 'basic',
            },
            {
                id: 'settings-industry-code',
                link: '/admin/settings/industry-code',
                icon: 'mat_outline:checklist',
                title: 'Industry Codes',
                type: 'basic',
            },
            {
                id: 'settings-industry-competency',
                link: '/admin/settings/industry-competency',
                icon: 'mat_outline:checklist',
                title: 'Industry Competencies',
                type: 'basic',
            },
            {
                id: 'settings-test-manager',
                link: '/admin/settings/test-manager',
                icon: 'mat_outline:folder_open',
                title: 'Test Management',
                type: 'basic',
            },
            {
                id: 'settings-legal',
                link: '/admin/settings/legal',
                icon: 'mat_outline:gavel',
                title: 'Legal',
                type: 'basic',
            },
            {
                id: 'settings-geo',
                link: '/admin/settings/geo',
                icon: 'mat_outline:map',
                title: 'Geography',
                type: 'basic',
            },
            {
                id: 'settings-schema-manager',
                link: '/admin/settings/schema',
                icon: 'mat_outline:settings_input_component',
                title: 'Schema Manager',
                type: 'basic',
            },
            {
                id: 'settings-quote-profiles',
                link: '/admin/settings/quote-profiles',
                icon: 'mat_outline:manage_accounts',
                title: 'Sales Quote Profiles',
                type: 'basic',
            },
            {
                id: 'settings-expense-report-options',
                link: '/admin/settings/expense-report-options',
                icon: 'mat_outline:manage_accounts',
                title: 'Expense Report Options',
                type: 'basic',
            }
        ]
    },
    {
        id: 'email-manager',
        title: 'Email Manager',
        type: 'collapsable',
        icon: 'mat_outline:email',
        link: '/admin/email-manager',
        children: [
            {
                id: 'email-manager-email-history',
                link: '/admin/email-manager/email-history',
                icon: 'mat_outline:email',
                title: 'Email History',
                type: 'basic',
            }
        ]
    },
    {
        id: 'Activity',
        title: 'Activity Console',
        type: 'basic',
        icon: 'mat_outline:sync_alt',
        link: '/admin/activity'
    }
]

export const auditorNavigation: FuseNavigationItem[] = [
    {
        id: 'quote-requests',
        title: 'Home',
        type: 'basic',
        icon: 'mat_outline:home',
        link: '/home'
    },
    {
        id: 'my-audits',
        title: 'My Audits',
        type: 'basic',
        icon: 'mat_outline:rate_review',
        link: '/auditor/audits'
    },
    {
        id: 'my-tests',
        title: 'My Tests',
        type: 'basic',
        icon: 'mat_outline:file_present',
        link: '/auditor/tests'
    },
    {
        id: 'my-calendar',
        title: 'My Calendar',
        type: 'basic',
        icon: 'mat_outline:calendar_today',
        link: '/auditor/calendar'
    },
    {
        id: 'my-reports',
        title: 'My Reports',
        type: 'basic',
        icon: 'mat_outline:inventory',
        link: '/auditor/reports'
    },
    {
        id: 'my-invoices',
        title: 'My Invoices',
        type: 'basic',
        icon: 'mat_outline:rate_review',
        link: '/auditor/invoices'
    },
    {
        id: 'my-documents',
        title: 'Documents',
        type: 'basic',
        icon: 'heroicons_outline:document',
        link: '/auditor/documents'
    },

    // {
    //     id: 'my-activities',
    //     title: 'Acitivities',
    //     type: 'basic',
    //     icon: 'mat_outline:bar_chart',
    //     link: '/auditor/activities'
    // }
];


export const customerNavigation: FuseNavigationItem[] = [
    {
        id: 'quote-requests',
        title: 'Home',
        type: 'basic',
        icon: 'mat_outline:home',
        link: '/home'
    },
    {
        id: 'my-quote',
        title: 'Quotes',
        type: 'basic',
        icon: 'mat_outline:request_quote',
        link: '/customer/my-quotes'
    },
    {
        id: 'my-applications',
        title: 'Applications',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-list',
        link: '/customer/applications'
    },
    {
        id: 'my-clients',
        title: 'Clients',
        type: 'basic',
        icon: 'mat_outline:business',
        link: '/customer/clients'
    },
    {
        id: 'my-audits',
        title: 'Audits',
        type: 'basic',
        icon: 'mat_outline:travel_explore',
        link: '/customer/audits'
    },
    {
        id: 'my-documents',
        title: 'Documents',
        type: 'basic',
        icon: 'mat_outline:snippet_folder',
        link: '/customer/documents'
    }
];

export const salesRepNavigation: FuseNavigationItem[] = [
    {
        id: 'quote-requests',
        title: 'My Requests',
        type: 'basic',
        icon: 'mat_outline:request_quote',
        link: '/home'
    },
    {
        id: 'sales-rep',
        title: 'Sales Rep',
        type: 'group',
        icon: 'mat_outline:admin_panel_settings',
        children: [
            {
                id: 'home',
                title: 'Home',
                type: 'basic',
                icon: 'mat_outline:home',
                link: '/home'
            },
            {
                id: 'clients',
                title: 'Clients',
                type: 'basic',
                icon: 'mat_outline:business',
                link: '/sales-rep/clients/list',
            },
            {
                id: 'sales',
                title: 'Sales',
                type: 'group',
                icon: 'mat_outline:attach_money',
                children: [
                    {
                        id: 'applications',
                        title: 'Applications',
                        type: 'basic',
                        icon: 'mat_outline:send_and_archive',
                        link: '/sales-rep/sales/quote-requests'
                    },
                    {
                        id: 'sales-quotes',
                        title: 'Quotes',
                        type: 'basic',
                        icon: 'mat_outline:request_quote',
                        link: '/sales-rep/sales/quotes'
                    },
                ]
            }
        ]
    }
];

export const salesRepCompactNavigation: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Home',
        type: 'basic',
        icon: 'mat_outline:home',
        link: '/home'
    },
    {
        id: 'clients',
        title: 'Clients',
        type: 'basic',
        icon: 'mat_outline:business',
        link: '/sales-rep/clients/list',
    },
    {
        id: 'sales',
        title: 'Sales',
        type: 'collapsable',
        icon: 'mat_outline:attach_money',
        children: [
            {
                id: 'applications',
                title: 'Applications',
                type: 'basic',
                icon: 'mat_outline:send_and_archive',
                link: '/sales-rep/sales/quote-requests'
            },
            {
                id: 'sales-quotes',
                title: 'Quotes',
                type: 'basic',
                icon: 'mat_outline:request_quote',
                link: '/sales-rep/sales/quotes'
            },
        ]
    }
];

export const salesManagerNavigation: FuseNavigationItem[] = [
    {
        id: 'quote-requests',
        title: 'Quote Request Queue',
        type: 'basic',
        icon: 'mat_outline:request_quote',
        link: '/home'
    }
];

export const clientNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'mat_outline:home',
        link: '/home'
    },
    {
        id: 'basic-Details',
        title: 'Basic Details',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/client/basic-details'
    },
    {
        id: 'certificate-Standards',
        title: 'Certificate Standards',
        type: 'basic',
        icon: 'heroicons_outline:check-circle',
        link: '/client/certificate-standards'
    },
    {
        id: 'sites',
        title: 'Sites',
        type: 'basic',
        icon: 'heroicons_outline:location-marker',
        link: '/client/sites'
    },
    {
        id: 'application',
        title: 'Applications',
        type: 'basic',
        icon: 'heroicons_outline:user-add',
        link: '/client/application'
    },
    {
        id: 'quotes',
        title: 'Quotes',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/client/quotes'
    },
    {
        id: 'certificate-management',
        title: 'Certificate Management',
        type: 'basic',
        icon: 'heroicons_outline:identification',
        link: '/client/certificate-management'
    },
    {
        id: 'audits',
        title: 'Audits',
        type: 'basic',
        icon: 'heroicons_outline:search-circle',
        link: '/client/audits'
    },
    {
        id: 'risk-matrix',
        title: 'Risk Matrix',
        type: 'basic',
        icon: 'heroicons_outline:shield-exclamation',
        link: '/client/risk-matrix'
    },
    {
        id: 'contact',
        title: 'Contact',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/client/contact'
    },
    {
        id: 'attached-documents',
        title: 'Attach Document',
        type: 'basic',
        icon: 'heroicons_outline:document-duplicate',
        link: '/client/attached-documents'
    },
    {
        id: 'activity-invoice',
        title: 'Active Invoice',
        type: 'basic',
        icon: 'mat_outline:receipt',
        link: '/client/activity-invoice'
    },
    {
        id: 'activity-console',
        title: 'Activity Console',
        type: 'basic',
        icon: 'mat_outline:sync_alt',
        link: '/client/activity-console'
    },
];

export const mmrNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'mat_outline:home',
        link: '/home'
    },
    {
        id: 'basic-Details',
        title: 'Basic Details',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: '/mmr/basic-details'
    },
    {
        id: 'clients',
        title: 'Clients',
        type: 'basic',
        icon: 'mat_outline:business',
        link: '/mmr/clients/list',
    },
    {
        id: 'attached-documents',
        title: 'Attach Document',
        type: 'basic',
        icon: 'heroicons_outline:document-duplicate',
        link: '/mmr/attached-documents'
    },
    {
        id: 'activity-console',
        title: 'Activity Console',
        type: 'basic',
        icon: 'mat_outline:sync_alt',
        link: '/mmr/activity'
    }
];

